// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StorageProgressBar {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.StorageProgressBar .StorageProgressBar-label {
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/modules/documents/storage-progress-bar/storage-progress-bar.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AACJ","sourcesContent":[".StorageProgressBar {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  .StorageProgressBar-label {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
